import { TravelDocumentSalesModel } from 'api-hooks/sale/travel-document';
import { ChevronDown } from 'baseui/icon';
import { XCircleSVG } from 'common/assets';
import { string2money } from 'common/utils/string';
import { Form, Input } from 'components/elements';
import { Button, IconButton } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import Text from 'components/elements/text';
import useDrawer from 'hooks/use-drawer';
import { SeparatorHorizontal } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import SummaryDrawer from './summary-drawer';
import useRecalculate from '../../hooks/use-recalculate';
import { DocumentSaleFormType } from '../form-type';
import {
  SummaryContent,
  SummaryLeftContainer,
  SummaryRightContainer,
} from '../styles';

interface Props {
  documentSales?: TravelDocumentSalesModel;
}

export default function BottomSection(props: Props) {
  const { documentSales } = props;
  const { t } = useTranslation();
  const drawer = useDrawer();

  const methods = useFormContext<DocumentSaleFormType>();

  const { total } = useRecalculate();

  const onOpenSummaries = React.useCallback(() => {
    drawer.showCustom({
      backdropClose: true,
      render(close) {
        return (
          <Form methods={methods} onSubmit={() => {}}>
            <SummaryDrawer onClose={close} />
          </Form>
        );
      },
    });
  }, [drawer, methods]);

  const { editable, setIsEditable } = useFormState();

  return (
    <SummaryContent>
      <SummaryLeftContainer>
        <Text variant={{ initial: 'LabelSmall', md: 'LabelLarge' }}>
          {t('common:total_sales')}:
        </Text>
        <SeparatorHorizontal $margin={16} />
        <Text
          variant={{ initial: 'HeadingXSmall', md: 'HeadingSmall' }}
        >{`Rp. ${string2money(total)}`}</Text>
        <SeparatorHorizontal $margin={16} />
        <IconButton buttonType="tertiary" onClick={onOpenSummaries}>
          <ChevronDown size={24} />
        </IconButton>
      </SummaryLeftContainer>
      {editable && (
        <SummaryRightContainer>
          {documentSales && (
            <>
              <Button
                buttonType="secondary"
                startEnhancer={(color, size) => (
                  <XCircleSVG size={size} color={color} />
                )}
                onClick={() => {
                  methods.reset();
                  setIsEditable(false);
                }}
                overrides={{
                  Root: {
                    style: {
                      flex: 1,
                    },
                  },
                }}
              >
                {t('common:cancel')}
              </Button>
              <SeparatorHorizontal $margin={24} />
            </>
          )}
          <Input
            type="submit"
            overrides={{
              Root: {
                style: {
                  flex: 1,
                },
              },
            }}
          />
        </SummaryRightContainer>
      )}
    </SummaryContent>
  );
}
